//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { RadioGroup } from '@components/primitives/radio-group/RadioGroup';
import { UIATrackingIds } from '@uia/constants/uiaConstants';

export enum RightsRequestPath {
  REQUEST = 'request-rights',
  SKIP = 'skip-rights',
}

export interface RightsRequestPathRadioGroupProps {
  rightsRequestPath: RightsRequestPath;
  setRightsRequestPath: (selectedValue: RightsRequestPath) => void;
}

export const RightsRequestPathRadioGroup = ({
  rightsRequestPath,
  setRightsRequestPath,
}: RightsRequestPathRadioGroupProps) => {
  return (
    <StyledRadioGroup
      onValueChange={setRightsRequestPath}
      value={rightsRequestPath}
    >
      <StyledRadioLabel>
        <RadioGroup.Item
          trackingId={UIATrackingIds.RIGHTS_REQUEST_PATH_CONTINUE}
          value={RightsRequestPath.REQUEST}
        >
          <RadioGroup.Indicator />
        </RadioGroup.Item>
        I want to request rights.
      </StyledRadioLabel>
      <StyledRadioLabel>
        <RadioGroup.Item
          trackingId={UIATrackingIds.RIGHTS_REQUEST_PATH_CONTINUE}
          value={RightsRequestPath.SKIP}
        >
          <RadioGroup.Indicator />
        </RadioGroup.Item>
        I don't want to request rights.
      </StyledRadioLabel>
    </StyledRadioGroup>
  );
};

const StyledRadioGroup = styled(RadioGroup)(
  ({ theme }) => `
    flex-direction: column;
    gap: ${theme.spacings[1]};
    padding: ${theme.spacings[1]} ${theme.spacings[0]};
  `,
);

const StyledRadioLabel = styled(RadioGroup.Label)(
  ({ theme }) => `
    display: flex;
    align-items: center;
    gap: ${theme.spacings[2]};
  `,
);
